import AppIntegrationManager from './integrations/integration-manager';

export default AppIntegrationManager;
